import { justDate, addDays, isWeekend } from './date-utils';

// Check if a date is a workable day (not weekend)
// NOTE: We don't skip holidays - user decides if they work on holidays
export function isWorkableDay(date) {
  if (isWeekend(date)) return false;
  return true;
}

// Get next workday after given date (skips weekends only)
export function nextWorkday(date) {
  let d = justDate(date);
  let attempts = 0;
  const maxAttempts = 30; // Safety limit
  
  while (!isWorkableDay(d) && attempts < maxAttempts) {
    d = addDays(d, 1);
    attempts++;
  }
  
  return d;
}

// Get previous workday before given date (skips weekends only)
export function previousWorkday(date) {
  let d = justDate(date);
  let attempts = 0;
  const maxAttempts = 30; // Safety limit
  
  while (!isWorkableDay(d) && attempts < maxAttempts) {
    d = addDays(d, -1);
    attempts++;
  }
  
  return d;
}

// Count workable days between two dates (inclusive, skips weekends only)
export function countWorkdaysBetween(startDate, endDate) {
  let count = 0;
  let current = justDate(startDate);
  const end = justDate(endDate);
  
  while (current <= end) {
    if (isWorkableDay(current)) {
      count++;
    }
    current = addDays(current, 1);
  }
  
  return count;
}

// Generate array of workable dates for a duration (skips weekends only, NOT holidays)
export function generateWorkdays(startDate, durationDays) {
  const workdays = [];
  let cursor = justDate(startDate);
  
  while (workdays.length < durationDays) {
    if (isWorkableDay(cursor)) {
      workdays.push(new Date(cursor));
    }
    cursor = addDays(cursor, 1);
  }
  
  return workdays;
}

// Add N workdays to a date (skipping weekends only)
export function addWorkdays(date, workdaysToAdd) {
  let current = justDate(date);
  let remaining = workdaysToAdd;
  
  while (remaining > 0) {
    current = addDays(current, 1);
    if (isWorkableDay(current)) {
      remaining--;
    }
  }
  
  return current;
}

// Subtract N workdays from a date (skipping weekends only)
export function subtractWorkdays(date, workdaysToSubtract) {
  let current = justDate(date);
  let remaining = workdaysToSubtract;
  
  while (remaining > 0) {
    current = addDays(current, -1);
    if (isWorkableDay(current)) {
      remaining--;
    }
  }
  
  return current;
}